export default __webpack_public_path__ + "static/media/tour-e-agency-mobile-three.cbdcd7f5.png";